import { Injectable } from '@angular/core';

import * as _ from 'lodash-es';

import { GfTranslateService } from '../../../../services/core.translate.service';
import { StateService } from '@uirouter/angular';

@Injectable()
export class CronReportHelper {

    constructor(
        private gfTranslateService: GfTranslateService,
        private stateService: StateService
    ) {}

    getSortFields() {
        return {
            'id': this.gfTranslateService.translate('ID'),
            'rundate': this.gfTranslateService.translate('Run Date'),
            'job': this.gfTranslateService.translate('Job Name')
        };
    }

    getAnyFilterObj() {
        return { id: '', label: this.gfTranslateService.translate("Any"), defaultSelected: true };
    }

    getCustomFilterObj() {
        return { id: null, label: this.gfTranslateService.translate("Custom"), defaultSelected: false };
    }

    getDateRangeElements() {
        return [
            this.getAnyFilterObj(),
            { id: '-7 days', label: this.gfTranslateService.translate("This Week") },
            { id: '-15 days', label: this.gfTranslateService.translate("Last 15 days") },
            { id: '-30 days', label: this.gfTranslateService.translate("Last 30 days") },
            { id: '-60 days', label: this.gfTranslateService.translate("Last 60 days") },
            { id: '-90 days', label: this.gfTranslateService.translate("Last 90 days") },
            { id: '-365 days', label: this.gfTranslateService.translate("Last year") }
        ];
    }

    getBaseFilters() {
        var any = this.getAnyFilterObj();

        var ret = [
            { alias: "job", fieldName: this.gfTranslateService.translate("Job Name"), value: '', fieldType: 4, isExtraField: false },
            { alias: "dateRange", fieldName: this.gfTranslateService.translate("Date Range"), value: any, fieldType: 1, isExtraField: false, fieldElements: this.getDateRangeElements() },
            { alias: "dateStart", fieldName: this.gfTranslateService.translate("Start Date"), value: '', fieldType: 9, isExtraField: false },
            { alias: "dateEnd", fieldName: this.gfTranslateService.translate("End Date"), value: '', fieldType: 9, isExtraField: false }
        ];
        return ret;
    }

    getSelectedElement(filter, stateParams) {
        var val = _.get(stateParams, filter.alias, false) || '';
        var elem = _.find(filter.fieldElements, { id: val });
        if (!elem) {
            elem = _.find(filter.fieldElements, { defaultSelected: true });
        }
        return elem;
    }

    setFiltersFromStateParams(filters) {
        return _.map(
            filters,
            (f) => {
                switch (f.fieldType) {
                    case 1: // list
                        f.value = this.getSelectedElement(f, this.stateService.params);
                        break;

                    default: // text/other
                        f.value = _.get(this.stateService.params, f.alias, '');
                        break;
                }
                return f;
            }
        );
    }    
}